import Header from "./components/Header";
import UpdateTicker from "./components/UpdateTicker";
import QuickEntries from "./components/QuickEntries";
import Hero from "./components/Hero";
import UpdateGrid from "./components/UpdateGrid";
import Collections from "./components/Collections";
import TagWall from "./components/TagWall";
import Rankings from "./components/Rankings";
import Discussions from "./components/Discussions";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50">
      <Header />
      <UpdateTicker />
      <QuickEntries />
      <main>
        <Hero />
        <UpdateGrid />
        <Collections />
        <TagWall />
        <Rankings />
        <Discussions />
      </main>
      <Footer />
    </div>
  );
}